// SideBar.js
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import { SERVER_URL } from './ServerConfig'
import queryString from 'query-string';

class SideBar extends Component {

    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);
        this.state = {
            redirectToDashboard: false,
            user: null,
            userName: "",
            collapsed: false,
            stations: [],
            warnings: {},
            totalWarnings : 0,
            params : params
        }
        this.handleSignout = this.handleSignout.bind(this);
    }

    handleSignout(event) {
        this.props.handleLogout();
        this.props.history.push("/login");
    }

    componentDidMount() {
        this.fetchUser();
        this.fetchStations();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.updateStation) {
            let params = queryString.parse(this.props.location.search);
            this.setState({params : params, totalWarnings : 0});
            this.fetchStations();
        }
    }

    fetchUser() {
        let tempUser = this.props.user.payload.user;
        var tempUserName = tempUser.mFirstName + " " + tempUser.mLastName;

        this.setState({ user: tempUser, userName: tempUserName });
    }

    fetchStations() {
        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;
        if (!user.member) {
            this.props.handleLogout();
            this.props.history.push("/login");
            return;
        }
        let project = user.member.mProjectID;

        fetch(SERVER_URL + '/v1/projects/' + project._id + '/getStations', {
            headers: {
                'x-access-token': token
            }
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (!data) {
                    return;
                }
                if (data.success) {
                    let stations = data.content;
                    this.setState({ stations: stations, totalWarnings : 0});
                    this.fetchWarnings(stations);
                }
            })
    }

    fetchWarnings(stations) {
        let token = this.props.user.payload.token;
        stations.forEach(station => {
            let stationId = station._id;
            fetch(SERVER_URL + '/v1/stations/' + stationId + '/warningInverters', {
                headers: {
                    'x-access-token': token
                }
            }).then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
                .then(data => {
                    if (data.success) {
                        let totalWarnings = this.state.totalWarnings;
                        let warningsSize = data.content.length;
                        totalWarnings += warningsSize;

                        let warnings = this.state.warnings;
                        warnings[stationId] = warningsSize;
                        this.setState({ totalWarnings: totalWarnings, warnings : warnings});
                    }
                });
        });
    }

    getTreeClassFor(item) {
        const pathName = window.location.pathname;
        if (pathName === '/' && item === '/dashboard') {
            return "menu-open";
        }
        return pathName.startsWith(item) ? "menu-open" : "";
    }

    getClassFor(item) {
        const pathName = window.location.pathname;
        if (pathName === '/' && item === '/dashboard') {
            return "active";
        }
        return pathName.startsWith(item) ? "active" : "";
    }

    getClassForActiveStation(station, item) {
        const pathName = window.location.pathname;
        if (!pathName.startsWith(item)) {
            return "";
        }
        let selectedStationId = this.state.params.station;
        if (selectedStationId && selectedStationId === station._id) {
            return "active"
        }
        return "";
    }

    getDashboardLinks() {
        return this.state.stations.map((station, idx) => {
            return (
                <li className="nav-item" key={station._id}>
                    <a href={"/dashboard?station=" + station._id} className={"nav-link " + this.getClassForActiveStation(station, '/dashboard')}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>{station.mName}</p>
                    </a>
                </li>
            )
        });
    }

    getInvertersLinks() {
        return this.state.stations.map((station, idx) => {
            return (
                <li className="nav-item" key={station._id}>
                    <a href={"/inverters?station=" + station._id} className={"nav-link " + this.getClassForActiveStation(station, '/inverters')}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>{station.mName}</p>
                    </a>
                </li>
            )
        });
    }

    getSettingLinks() {
        return this.state.stations.map((station, idx) => {
            return (
                <li className="nav-item" key={station._id}>
                    <a href={"/settings?station=" + station._id} className={"nav-link " + this.getClassForActiveStation(station, '/settings')}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>{station.mName}</p>
                    </a>
                </li>
            )
        });
    }

    getAlarmLinks() {
        return this.state.stations.map((station, idx) => {
            return (
                <li className="nav-item" key={station._id}>
                    <a href={"/alarms?station=" + station._id} className={"nav-link " + this.getClassForActiveStation(station, '/alarms')}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>{station.mName}</p>
                        {this.getAlarmBadgeForStation(station)}
                    </a>
                </li>
            )
        });
    }

    getAlarmBadgeForStation(station) {
        let warningsForStation = this.state.warnings[station._id];
        if (warningsForStation && warningsForStation > 0) {
            return (<span className="badge badge-danger navbar-badge">{warningsForStation}</span>);
        }
    }

    getAlarmBadgeForProject() {
        let totalWarnings = this.state.totalWarnings;
        if (this.state.totalWarnings > 0) {
            return (<span className="badge badge-danger right">{totalWarnings}</span>)
        }
    }

    render() {
        return (
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                <div className="d-flex brand-header">
                    <a href="/" className="brand-link brand-link-custom">
                        <img src="img/sun-128x128.png" alt="AdminLTE Logo" className="brand-image img-circle elevation-3"
                            style={{ opacity: .8 }} />
                        <span className="brand-text font-weight-light">Solar Monitoring</span>
                    </a>
                </div>

                <div className="sidebar">
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            <li className={"nav-item has-treeview " + this.getTreeClassFor("/dashboard")}>
                                <a href="" className={"nav-link " + this.getClassFor("/dashboard")}>
                                    <i className="nav-icon fas fa-tachometer-alt"></i>
                                    <p>
                                        Dashboard
                <i className="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul className="nav nav-treeview">
                                    {this.getDashboardLinks()}
                                </ul>
                            </li>
                            <li className={"nav-item has-treeview " + this.getTreeClassFor("/inverters")}>
                                <a href="" className={"nav-link " + this.getClassFor("/inverters")}>
                                    <i className="nav-icon fas fa-th"></i>
                                    <p>
                                        Inverters
                                        <i className="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul className="nav nav-treeview">
                                    {this.getInvertersLinks()}
                                </ul>
                            </li>
                            <li className={"nav-item has-treeview " + this.getTreeClassFor("/settings")}>
                                <a href="" className={"nav-link " + this.getClassFor("/settings")}>
                                    <i className="nav-icon fas fa-wrench"></i>
                                    <p>
                                    Settings
                <i className="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul className="nav nav-treeview">
                                    {this.getSettingLinks()}
                                </ul>
                            </li>
                            <li className={"nav-item has-treeview " + this.getTreeClassFor("/alarms")}>
                                <a href="" className={"nav-link " + this.getClassFor("/alarms")}>
                                    <i className="nav-icon fas fa-bell"></i>
                                    <p>
                                        Alarms
                                    <i className="right fas fa-angle-left"></i>
                                    {this.getAlarmBadgeForProject()}
                                    </p>
                                </a>
                                <ul className="nav nav-treeview">
                                    {this.getAlarmLinks()}
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link to="/members" className={"nav-link " + this.getClassFor("/members")}>
                                    <i className="nav-icon fas fa-users"></i>
                                    <p>Members</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/profile" className={"nav-link " + this.getClassFor("/profile")}>
                                    <i className="nav-icon fas fa-user-circle"></i>
                                    <p>Profile</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link nav-custom-link" onClick={this.handleSignout}>
                                    <i className="nav-icon fas fa-sign-out-alt"></i>
                                    <p>Logout</p>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>
        )
    }
}

export default withRouter(SideBar);